import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Stepper from "./Stepper";
import SelectStudents from "./SelectStudents";
import ActivityCreations from "./ActivityCreations";

const ActivityCreationManagementFlow = () => {
  const { id } = useParams(); // 👈 detect edit mode

  const [step, setStep] = useState(1);
  const [selectedData, setSelectedData] = useState({});

  // ⚡ When id is present → directly jump to Step 2
  useEffect(() => {
    if (id) {
      setStep(1);

      // Optionally load data for edit mode
      // fetchActivityDetails(id);
    }
  }, [id]);

  const handleNext = (data) => {
    // setSelectedData(data);
    // setStep(2);
  };

   
  

  return (
    <>
      {/* <Stepper step={step} editId={id} /> */}

      {/* {step === 1 && id && ( */}
        <SelectStudents onNext={handleNext} editId={id} selectedData={selectedData}/>
      {/* )} */}

      {/* {(step === 2 || id) && (
        <ActivityCreations
          selectedData={selectedData}
          onBack={() => setStep(1)}
          editId={id}
        />
      )} */}
    </>
  );
};

export default ActivityCreationManagementFlow;
